import Forms from "./Forms"
import RequestAccessCode from "./RequestAccessCode"
import EapSupport from "./EapSupport-OLD"
import EapSupportForm from "./EapSupportForm"
import LegalSupport from "./LegalSupport"

export {RequestAccessCode, EapSupportForm, LegalSupport}
export default Forms
